export default class extends HTMLElement {

  static get observedAttributes() {
    return ['settings'];
  }

  constructor() {
    super();
    console.log('Init DSBStepBar');
    this._steps={};
    this.messages=null;
    this._contentElements={};
    this._contentElements.list=null;
    this._contentElements.bar=null;
    this._contentElements.progress=null;
    this._contentElements.progress_header=null;
  }

  get settings() {
      if(!this._settings)
      {
          if(typeof this.getAttribute('settings') === 'object' && this.getAttribute('settings') !== null)
          {
              this._settings = this.getAttribute('settings');
          }
          else
          {
            this._settings = JSON.parse(``+this.getAttribute('settings')+``);
          }

          if(this._settings == null)
          {
              this._settings = {};
          }
      }
      return this._settings;
  }

  set settings(newValue){
      if(typeof newValue === 'object' && newValue !== null)
      {
        this._settings = newValue;
      }
      else
      {
          this.setAttribute('settings', newValue);
      }
  }

  attributeChangedCallback(name, oldValue, newValue)
  {
    if(`settings` == name && oldValue != null)
    {
      console.log('dsb-stepbar::attributeChangedCallback: '+name,oldValue,newValue);
      for(let aStep in this._steps)
      {
        if(this._steps[aStep].component instanceof HTMLUListElement)
        {
          delete this._step[aStep].component;
        }
      }
      return this._render();
    }
  }

  setHeader(message)
  {
    this._update();
    this.message = message;
    this._refreshHeader();
  }

  _refreshHeader()
  {
    if(this.message instanceof Function)
    {
      this.message(this._contentElements.progress_header,this._getStats());
    }
    else
    {
      this._contentElements.progress_header.innerHTML = this.message;
    }
  }

  setStep(name,status='default',upsert_mode=true,onclick_function=false)
  {
    if(name in this._steps)
    {
      let status_change=false;
      if(this._steps[name].status!==status)
      {
        status_change=true;
      }
      if(onclick_function && typeof onclick_function === 'function' )
      {
        this._steps[name].component.onclick=onclick_function;
        this._steps[name].component.style.cursor='pointer';
      }

      if(status=='active')
      {
        status_change=false;
        for(let _step in this._steps)
        {
          if(this._steps[_step].component.classList.contains('active'))
          {
            this._steps[_step].component.classList.remove('active');
          }
        }
        this._steps[name].component.classList.add('active');
        this._steps[name].component.style.height=(parseInt(this._steps[name].component.style.width)*2);
        this._steps[name].component.style.width=(parseInt(this._steps[name].component.style.width)*2);
        /**
        if(typeof this.settings === 'object' && this.settings !== null && 'active_color' in this.settings)
        {
          this._steps[aStep].component.style.borderColor=this.settings.active_color;
        }
        */
        return;
      }
      else
      {
        this._steps[name].status=status;
        this._refresh_step(name,status_change);
      }
    }
    else if(upsert_mode)
    {
      this._steps[name]={'name':name,'status':status};
      this._refresh_step(name,true);
    }
  }

  _refresh_step(aStep,refresh_progress=false)
  {
    if(aStep in this._steps)
    {
      if(!(`progress_mode` in this.settings))
      {
        this.settings.progress_mode = 'percentage';
      }

      if(!(`size` in this.settings))
      {
        this.settings.size = '10px';
      }


      if(!('component' in this._steps[aStep]) || !(this._steps[aStep].component instanceof HTMLLIElement))
      {
        this._steps[aStep].component = document.createElement("li");
        this._update(this._steps[aStep].component);
      }

      // Run settings

      if(this.settings !== null && 'size' in this.settings)
      {
        this._steps[aStep].component.style.height=this.settings.size;
        this._steps[aStep].component.style.width=this.settings.size;
        if(this._contentElements.progress instanceof HTMLElement)
        {
          let width_size = (parseInt(this.settings.size)*0.1);
          this._contentElements.progress.style.height=(width_size>1?width_size:1);
          this._contentElements.progress_background.style.height=(width_size>1?width_size:1);
        }
      }


      // Run label
      if('label' in this._steps[aStep])
      {
        this._steps[aStep].component.setAttribute('alt',this._steps[aStep].label);
      }

      if('name' in this._steps[aStep])
      {
        this._steps[aStep].component.setAttribute('alt',this._steps[aStep].name);
      }
      if('status' in this._steps[aStep])
      {
        if('complete' == this._steps[aStep].status)
        {
          this._steps[aStep].component.classList.add('complete');
          /**
          if(typeof this.settings === 'object' && this.settings !== null && 'complete_color' in this.settings)
          {
            this._steps[aStep].component.style.borderColor=this.settings.complete_color;
            this._steps[aStep].component.style.background=this.settings.complete_color;
            if(this._contentElements.progress instanceof HTMLElement)
            {
              this._contentElements.progress.style.background=this.settings.complete_color;
            }
          }
          */
        }

        if(refresh_progress && (this._contentElements.progress instanceof HTMLElement))
        {
          let stats = this._getStats();
          if(this.settings !== null && 'progress_mode' in this.settings && `percentage` == this.settings.progress_mode)
          {
            this._contentElements.progress.style.width=((stats.count/stats.total)*100)+'%';
          }
          else if(this.settings !== null && 'progress_mode' in this.settings && `stage` == this.settings.progress_mode)
          {
            this._contentElements.progress.style.width=((100/(stats.total-1))*stats.count)+'%';
          }

          if(parseInt(this._contentElements.progress.style.width.replace('%','')) > 100)
          {
            this._contentElements.progress.style.width = '100%';
          }

        }
        this._refreshHeader();
      }
      return this._steps[aStep].component;
    }
    else
    {
      console.error('DSBStepBar:: Missing step '+aStep);
    }
  }

  _getStats()
  {
    let _count =0;
    let _total = 0;
    for(let _step in this._steps)
    {
      _total++;
      if(('status' in this._steps[_step]))
      {
        if('complete' == this._steps[_step].status)
        {
          _count++;
        }
      }
    }
    return {'count':_count,'total':_total};
  }

  _update(item=null)
  {
    if(!(this._contentElements.progress instanceof HTMLElement))
    {
      this.innerHTML = '';

      this._contentElements.progress_header = document.createElement("span");
      this._contentElements.progress_header.classList.add('progress-header');
      this.append(this._contentElements.progress_header)

      this._contentElements.bar = document.createElement("div");
      this._contentElements.bar.classList.add('bar');

      this._contentElements.progress_background = document.createElement("span");
      this._contentElements.progress_background.classList.add('progress-background');
      this._contentElements.bar.append(this._contentElements.progress_background);
      this._contentElements.progress = document.createElement("span");
      this._contentElements.progress.classList.add('progress');
      this._contentElements.bar.append(this._contentElements.progress);

      this.append(this._contentElements.bar);
    }

    if(!(this._contentElements.list instanceof HTMLUListElement))
    {
      this._contentElements.list = document.createElement("ul");
      this._contentElements.bar.append(this._contentElements.list);
    }

    if(item instanceof HTMLLIElement)
    {
      if(typeof this.settings === 'object' && this.settings !== null && 'add_order' in this.settings && ( this.settings.add_order=='prepend'))
      {
        this._contentElements.list.prepend(item);
      }
      else
      {
        this._contentElements.list.append(item);
      }
    }
    return;
  }

  connectedCallback() {
    this._render();
  }

  _render()
  {
    //let copy = this.innerHTML;
    this._update();

    for(let aStep in this._steps)
    {
      this._refresh_step(aStep,true);
    }
  }
}

